import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import type { GroupScope } from 'features/groups/models';

export const useNavigateToGroupEntity = () => {
  const replace = useNavigate();

  return useCallback(
    async (groupId: string, scope: GroupScope) => {
      await replace(routes.group.entities(groupId, scope));
    },
    [replace],
  );
};
